module.exports = __webpack_public_path__ + "img/zhifuchenggong.8d855586.png";